// noinspection ES6UnusedImports
import React, {Fragment} from 'react';
import createInformationLayerTextWithLink from './create-information-layer-text-with-link.jsx';
import {Typography} from "@bonprix/design-system";

export default function BatteryDisposalNote({texts, linkTarget}) {
    return (
        <Typography variant="body1">
            <div>{texts.battery_disposal_paragraph_first}</div>
            <div>{texts.battery_disposal_paragraph_second}</div>
            <div>
                <img
                    src="https://image01.bonprix.de/bonprixbilder/service/entsorgung/icon-entsorgen-2-62x42-144-270041.png"
                    className="product-information__layer-image"
                    alt="battery-disposal-icon"
                />
            </div>
            {createInformationLayerTextWithLink(texts.battery_disposal_link_description, linkTarget)}
        </Typography>
    );
}
